'use strict';

Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: 'Module' } });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const Downshift = require('downshift');
const React = require('react');
const components_forms_FloatingMenu_FloatingMenu = require('../FloatingMenu/FloatingMenu.cjs.js');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_forms_Typeahead_TypeaheadInput = require('./TypeaheadInput.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const Downshift__default = /*#__PURE__*/_interopDefault(Downshift);
const React__default = /*#__PURE__*/_interopDefault(React);

const dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, " ").trim();
const defaultFilterItems = (inputValue, items, getLabelForItem, showEmptyList = false) => {
  if (showEmptyList || !inputValue) {
    return items;
  }
  const lowerCaseInput = inputValue.toLowerCase();
  return items.filter((item) => {
    return getLabelForItem(item).toLowerCase().includes(dedupeAndTrimWhitespace(lowerCaseInput));
  });
};
const Styles = styleEncapsulation.labelStyles("Typeahead", {
  root: () => [
    {
      position: "relative"
    }
  ]
});
class Typeahead extends React__default.default.Component {
  constructor() {
    super(...arguments);
    this.itemToString = (item) => {
      return item ? this.props.getLabelForItem(item) : "";
    };
    this.stateReducer = (state, changes) => {
      if (this.props.keepInputValueOnBlur && (changes.type === Downshift__default.default.stateChangeTypes.blurInput || changes.type === Downshift__default.default.stateChangeTypes.mouseUp)) {
        return Object.assign(Object.assign({}, changes), { inputValue: state.inputValue });
      }
      return changes;
    };
  }
  render() {
    const { props } = this;
    return react.jsx(Downshift__default.default, { id: props.id, initialSelectedItem: props.selectedItem || props.initialSelectedItem, inputId: props.inputId, inputValue: props.inputValue, itemToString: this.itemToString, labelId: props.labelId, onChange: props.onChange, onInputValueChange: props.onInputValueChange, selectedItem: props.selectedItem, stateReducer: this.stateReducer }, ({
      clearSelection,
      getInputProps,
      getItemProps,
      getMenuProps,
      getRootProps,
      highlightedIndex,
      // This does exist, it's just not in the typings.
      // We're using an old version of downshift
      // @ts-ignore
      inputId,
      inputValue,
      isOpen,
      openMenu,
      selectedItem
    }) => {
      if (props.setClearSelection) {
        props.setClearSelection(clearSelection);
      }
      const ariaLabelledBy = props.labelId || null;
      const _a = getRootProps({
        // @ts-ignore
        "aria-labelledby": ariaLabelledBy,
        refKey: "innerRef"
      }, { suppressRefError: true }), { innerRef } = _a, rootProps = tslib_es6.__rest(_a, ["innerRef"]);
      const filteredItems = props.filterItems(inputValue, props.items, props.getLabelForItem, props.showEmptyList || false);
      const showMenu = isOpen && filteredItems.length > 0;
      const isErrored = props.showErrorOnNoResults && inputValue && filteredItems.length === 0 || props.isErrored;
      return react.jsx(
        "div",
        Object.assign({}, rootProps, { css: Styles.root(), ref: innerRef, "data-zds": true }),
        react.jsx(components_forms_Typeahead_TypeaheadInput.TypeaheadInput, { "aria-label": props["aria-label"], "aria-labelledby": ariaLabelledBy, autoComplete: props.autoComplete, clearSelection, disabledText: props.disabledText, getInputProps, getLabelForItem: props.getLabelForItem, iconEndName: props.iconEndName, inputValue, isBusy: props.isBusy, isDisabled: props.isDisabled, isErrored: !!isErrored, onFocus: props.openOnFocus ? openMenu : void 0, onKeyDown: props.onKeyDown, placeholder: props.placeholder, ref: props.inputRef, renderIcon: props.renderIcon, selectedItem, size: props.size, onBlur: props.onBlur }),
        showMenu && props.renderFloatingMenu({
          "aria-label": props.menuAriaLabel,
          getItemProps,
          getKeyForItem: props.getKeyForItem,
          getLabelForItem: props.getLabelForItem,
          getMenuProps,
          highlightedIndex,
          items: filteredItems,
          renderIcon: props.renderIcon
        })
      );
    });
  }
}
Typeahead.defaultProps = {
  filterItems: defaultFilterItems,
  isDisabled: false,
  openOnFocus: false,
  renderFloatingMenu: (props) => react.jsx(components_forms_FloatingMenu_FloatingMenu.FloatingMenu, Object.assign({}, props)),
  showEmptyList: false,
  showErrorOnNoResults: false
};

exports.Typeahead = Typeahead;
exports.default = Typeahead;
//# sourceMappingURL=Typeahead.cjs.js.map
